import React from 'react';

export const ShippingExpress = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 42.74 41.67"
      width="52px"
      {...props}
    >
      <g>
        <path
          fill="#26375f"
          d="M29.58 21.9L34 31.55a1.35 1.35 0 001.8.66 1.19 1.19 0 00.39-.27l2.05-2.05a1.36 1.36 0 00.39-1.13L37.1 16.22A1.37 1.37 0 0035.58 15a1.34 1.34 0 00-.78.38l-4.95 5a1.36 1.36 0 00-.27 1.52zM25.35 6.86L13.27 5.35a1.35 1.35 0 00-1.12.39L10.09 7.8a1.35 1.35 0 00.39 2.2l9.29 4.29a1.36 1.36 0 001.52-.29l4.85-4.85a1.35 1.35 0 000-1.91 1.31 1.31 0 00-.79-.38z"
        />
        <path
          fill="#26375f"
          d="M41.43 1.32a4.51 4.51 0 00-6.38 0l-21.6 21.6a1.37 1.37 0 01-1.48.31l-2.25-.86a1.38 1.38 0 00-1.48.31l-2.08 2.08a1.39 1.39 0 000 2 1.34 1.34 0 00.49.32l6 2.3a1.4 1.4 0 01.8.8l2.3 6a1.39 1.39 0 001.8.8 1.52 1.52 0 00.48-.31l2.07-2.07a1.41 1.41 0 00.31-1.5l-.9-2.28a1.4 1.4 0 01.31-1.49l21.6-21.6a4.51 4.51 0 000-6.38z"
        />
        <g fill="#337489">
          <path d="M2.62 24.62l12.26-9.74A.6.6 0 0015 14a.63.63 0 00-.22-.18l-.78-.31a.8.8 0 00-.91.16l-1.45 1.45zM10.15 11.74l-.87-.4a.86.86 0 00-1 .18L6.78 13 0 20.79l10.26-8.19a.52.52 0 00.08-.72.45.45 0 00-.19-.14zM28.07 27.73L18.8 39.34l8.87-8.17 1.51-1.51a.84.84 0 00.17-1l-.35-.82a.52.52 0 00-.7-.26.45.45 0 00-.23.15zM24.25 41.67L29.76 36l1.63-1.63a.81.81 0 00.17-.92l-.39-.83a.51.51 0 00-.67-.25.61.61 0 00-.21.18z" />
        </g>
      </g>
    </svg>
  );
};
